export const EManualExternalOrderReconciliationStatus = {
  NotReconciled: 0,
  WaitingPayment: 1,
  ReceivedWithDifference: 2,
  Reconciled: 3,
  Ignored: 4,
} as const

export type EManualExternalOrderReconciliationStatus =
  (typeof EManualExternalOrderReconciliationStatus)[keyof typeof EManualExternalOrderReconciliationStatus]
